module.exports = __webpack_public_path__ + "img/otdrshop.bfe24766.png";